document.querySelectorAll('.footer-link-title').forEach(btn => {
  btn.addEventListener('click', () => {
    if (!window.matchMedia('(max-width: 1200px)').matches) return;

    const item = btn.closest('.footer-link');
    const isOpen = item.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', isOpen);
  });
});



document.querySelectorAll('.footer-link.is-open').forEach(el => {
  if (el !== item) el.classList.remove('is-open');
});


document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-copy]');
  if (!btn) return;
  e.preventDefault();
  navigator.clipboard.writeText(btn.dataset.copy).then(() => {
    btn.classList.add('copied');
    setTimeout(() => btn.classList.remove('copied'), 1500);
  });
});



const toggleBtn = document.querySelector('.search-toggle');
const searchArea = document.querySelector('.mobile-search-area');

toggleBtn.addEventListener('click', () => {
  const isVisible = getComputedStyle(searchArea).display !== 'none';

  searchArea.style.display = isVisible ? 'none' : 'block';
  toggleBtn.setAttribute('aria-expanded', !isVisible);
});